import { getIn } from 'seamless-immutable';

import config from '@catalogo/core-configuration/config/out/config.server.json';

import { formatPayment } from './format-payment';

const validateDiscount = (mainPayment, secondaryPayment) => {
  const mainPaymentDiscount = mainPayment.discount.rate;
  const secondaryPaymentDiscount = secondaryPayment.discount.rate;

  if (mainPaymentDiscount === secondaryPaymentDiscount) {
    secondaryPayment.discount = {};
  }

  return secondaryPayment;
};

const getType = type => {
  switch (type) {
    case 'CARTAO_VISA':
      return 'cartaoVisa';
    case config.brandCardId:
      return 'cartaoMarca';
    case 'BOLETO':
      return 'boleto';
    case 'PIX':
      return 'pix';
    default:
      return null;
  }
};

export const getPayments = offer => {
  const type = getType(getIn(offer, ['bestPaymentOption', 'type'], ''));
  const mainPayment = formatPayment(offer, type);
  const secondaryPayment = validateDiscount(mainPayment, formatPayment(offer, 'cartaoMarca'));

  if (type === 'cartaoMarca') {
    return { mainPayment };
  }

  const samePrice = secondaryPayment.price === mainPayment.price;
  const betterInstallment = secondaryPayment.selectedQty > mainPayment.selectedQty;
  const isDifferentPayment = samePrice && betterInstallment;

  if (!samePrice || isDifferentPayment) {
    return { mainPayment, secondaryPayment };
  }

  return { mainPayment };
};
